module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEditSupplier.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.social_reason),
      expression: "supplier_current.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier_current.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.nit),
      expression: "supplier_current.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier_current.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Contacto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact),
      expression: "supplier_current.contact"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.country),
      expression: "supplier_current.country"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Ciudad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.city),
      expression: "supplier_current.city"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.address),
      expression: "supplier_current.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.telphone),
      expression: "supplier_current.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.cellphone),
      expression: "supplier_current.cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.email),
      expression: "supplier_current.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier_current.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_name),
      expression: "supplier_current.contact_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_cellphone),
      expression: "supplier_current.contact_cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_email),
      expression: "supplier_current.contact_email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.link),
      expression: "supplier_current.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditSupplier()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.suppliers), function(supplier) {
    return _c('tr', {
      key: ("supplier-" + (supplier.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.social_reason))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.nit))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.email))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.country))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(supplier.link) ? _c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": supplier.link,
        "target": "_blank"
      }
    }, [_vm._v("link")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": ("/admin/business/suppliers/relations/" + (supplier.id))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Razones\n                  ")], 1), _vm._v(" "), _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editSupplier(supplier)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "supplier"
    }
  }, [_c('div', {
    staticClass: "modal__content"
  }, [_vm._m(4), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createSupplier.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.social_reason),
      expression: "supplier.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.nit),
      expression: "supplier.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Contacto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact),
      expression: "supplier.contact"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.country),
      expression: "supplier.country"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Ciudad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.city),
      expression: "supplier.city"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.address),
      expression: "supplier.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.telphone),
      expression: "supplier.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.cellphone),
      expression: "supplier.cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.email),
      expression: "supplier.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_name),
      expression: "supplier.contact_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_cellphone),
      expression: "supplier.contact_cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact_cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_email),
      expression: "supplier.contact_email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.link),
      expression: "supplier.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(6)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#supplier",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Proveedor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          Editar Cuenta\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Contacto Adicional\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RAZON SOCIAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NIT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CORREO ELECTRONICO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PAIS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Proveedor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Adicional\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69f76d32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/suppliers/ListSuppliers.vue
// module id = 452
// module chunks = 1